import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import axios from "axios";

/* /account/link?token=… , swaps a one-time login link for a session. */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HQLoginLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("That link is missing its code. Please request a new one."); return; }
    axios.post(`${API}/customer/access/consume`, { token })
      .then(({ data }) => {
        localStorage.setItem("heritage-customer-token", data.token);
        if (data.email) localStorage.setItem("heritage-customer-email", data.email);
        if (data.name) localStorage.setItem("heritage-customer-name", data.name);
        window.dispatchEvent(new Event("heritage-customer-session"));
        navigate("/account", { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || "That link didn't work. Please request a new one."));
  }, [params, navigate]);

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#E8DCEB]" data-testid="hq-login-link">
      <div className="max-w-md w-full bg-[#F2EAF3] border-2 border-[#3E2346] p-8 text-center text-[#3E2346]">
        <KeyRound className="w-7 h-7 mx-auto" />
        {error ? (
          <>
            <h1 className="font-serif text-2xl mt-3">We couldn't open that link</h1>
            <p className="text-sm mt-2" data-testid="hq-login-link-error">{error}</p>
            <Link to="/account/login" className="mt-5 inline-flex h-12 px-5 items-center bg-[#6E1E3A] text-white text-xs font-semibold tracking-[0.14em] uppercase">
              Go to sign in
            </Link>
          </>
        ) : (
          <>
            <h1 className="font-serif text-2xl mt-3">Signing you in…</h1>
            <Loader2 className="w-5 h-5 animate-spin mx-auto mt-3" />
          </>
        )}
      </div>
    </div>
  );
}
